import { DistributionPromoMechanic } from "./distribution-promo-mechanic"
import { DistributionPromoDetailSku } from "./distribution-promo-sku"

export class DistributionPromoDetail { 
    private id: number
    private distribution_promo_sku: DistributionPromoDetailSku[] = [];
    private distribution_promo_brand: DistributionPromoDetailSku[] = [];
    private distribution_promo_category: DistributionPromoDetailSku[] = [];

    public get _id(): number {
        return this.id;
    }
    public set _id(value: number) {
        this.id = value;
    }
    
    private temp_id: number
    public get _temp_id(): number {
        return this.temp_id;
    }
    public set _temp_id(value: number) {
        this.temp_id = value;
    }

    private distribution_promo_id: number;
    public get _distribution_promo_id(): number {
        return this.distribution_promo_id;
    }
    public set _distribution_promo_id(value: number) {
        this.distribution_promo_id = value;
    }

    private description: string;
    public get _description(): string {
        return this.description;
    }
    public set _description(value: string) {
        this.description = value;
    }

    private priority: number;
    public get _priority(): number {
        return this.priority;
    }
    public set _priority(value: number) {
        this.priority = value;
    }

    private start_date: string;
    public get _start_date(): string {
        return this.start_date;
    }
    public set _start_date(value: string) {
        this.start_date = value;
    }

    private end_date: string;
    public get _end_date(): string {
        return this.end_date;
    }
    public set _end_date(value: string) {
        this.end_date = value;
    }

    private capacity: number;
    public get _capacity(): number {
        return this.capacity;
    }
    public set _capacity(value: number) {
        this.capacity = value;
    }

    private capacity_reset_period: string;
    public get _capacity_reset_period(): string {
        return this.capacity_reset_period;
    }
    public set _capacity_reset_period(value: string) {
        this.capacity_reset_period = value;
    }

    private capacity_reset_period_qty: number;
    public get _capacity_reset_period_qty(): number {
        return this.capacity_reset_period_qty;
    }
    public set _capacity_reset_period_qty(value: number) {
        this.capacity_reset_period_qty = value;
    }

    private capacity_reset_day: string;
    public get _capacity_reset_day(): string {
        return this.capacity_reset_day;
    }
    public set _capacity_reset_day(value: string) {
        this.capacity_reset_day = value;
    }

    private mechanic_period: string;
    public get _mechanic_period(): string {
        return this.mechanic_period;
    }
    public set _mechanic_period(value: string) {
        this.mechanic_period = value;
    }

    private apply_for_every_nth_pcs: number;
    public get _apply_for_every_nth_pcs(): number {
        return this.apply_for_every_nth_pcs;
    }
    public set _apply_for_every_nth_pcs(value: number) {
        this.apply_for_every_nth_pcs = value;
    }

    private apply_discount_to: string;
    public get _apply_discount_to(): string {
        return this.apply_discount_to;
    }
    public set _apply_discount_to(value: string) {
        this.apply_discount_to = value;
    }

    private is_distribution_date: boolean;
    public get _is_distribution_date(): boolean {
        return this.is_distribution_date;
    }
    public set _is_distribution_date(value: boolean) {
        this.is_distribution_date = value;
    }

    private distribution_promo_mechanic: DistributionPromoMechanic[];
    public get _distribution_promo_mechanic(): DistributionPromoMechanic[] {
        return this.distribution_promo_mechanic;
    }
    public set _distribution_promo_mechanic(value: DistributionPromoMechanic[]) {
        this.distribution_promo_mechanic = value;
    }

    public get _distribution_promo_sku(): DistributionPromoDetailSku[] {
        return this.distribution_promo_sku;
    }
    public set _distribution_promo_sku(value: DistributionPromoDetailSku[]) {
        this.distribution_promo_sku = value;
    }

    private use_distribution_start_end_date: number;
    public get _use_distribution_start_end_date(): number {
        return this.use_distribution_start_end_date;
    }
    public set _use_distribution_start_end_date(value: number) {
        this.use_distribution_start_end_date = value;
    }

    public get _distribution_promo_brand(): DistributionPromoDetailSku[] {
        return this.distribution_promo_brand;
    }
    public set _distribution_promo_brand(value: DistributionPromoDetailSku[]) {
        this.distribution_promo_brand = value;
    }

    public get _distribution_promo_category(): DistributionPromoDetailSku[] {
        return this.distribution_promo_category;
    }
    public set _distribution_promo_category(value: DistributionPromoDetailSku[]) {
        this.distribution_promo_category = value;
    }

    private _brand_is_all:boolean
    public get brand_is_all(): boolean {
        return this._brand_is_all;
    }
    public set brand_is_all(value: boolean) {
        this._brand_is_all = value;
    }

    private _item_is_all:boolean
    public get item_is_all(): boolean {
        return this._item_is_all;
    }
    public set item_is_all(value: boolean) {
        this._item_is_all = value;
    }
}